
const ArDesktopModal = () => ({
  pageUrl: "",
  init() {
    const container = this.$el
    this.pageUrl = container.dataset.pageUrl
    const urlParams = new URLSearchParams(window.location.search)
    this.variantId = urlParams.get("variant")
    this.firstVariant = container.dataset.firstVariant
  },

  openDesktopModal() {
      this.generateQR();
  },

  closeDesktopModal() {
    window.dispatchEvent(new CustomEvent("closeARTrigger"))
  },

 async generateQR() {
    const qrContainer = this.$el.querySelector("#ar-modal-qr-code");

    if (!qrContainer) {
      return
    }

    const variantId = this.variantId || this.firstVariant

    qrContainer.innerHTML = ""

    new QRCode(
      qrContainer,
      `${this.pageUrl}?variant=${variantId}#open-ar=true`,
      { width: 168, height: 168, color: { dark: "#000000", light: "#ffffff" } },
      (error) => error && console.error("QR Code generation failed:", error),
    )
  },
})

export default ArDesktopModal

